import PageContainer from '../../../components/page-container';
import { APP_NAVIGATION } from '../consts/navigations';
import './settings-layout.css';

export default function SettingsPage({ title, subtitle, headerAction, navigationPosition = 'above-header', children }) {
  return (
    <div className="settings-page min-h-full text-gray-900">
      <PageContainer
        title={title}
        subtitle={subtitle}
        headerAction={headerAction}
        navigation={APP_NAVIGATION}
        navigationPosition={navigationPosition}
      >
        <div className="space-y-6 pb-10">{children}</div>
      </PageContainer>
    </div>
  );
}

export function SettingsSection({ title, description, children, action }) {
  return <section className="min-w-0 rounded-2xl border border-gray-200 bg-white shadow-sm">
    <div className="flex flex-wrap items-center justify-between gap-3 border-b border-gray-100 px-5 py-5 sm:px-6">
      <div><h2 className="text-base font-semibold tracking-tight">{title}</h2>{description && <p className="mt-1 text-sm leading-6 text-gray-500">{description}</p>}</div>{action}
    </div>
    <div className="space-y-5 p-5 sm:p-6">{children}</div>
  </section>;
}

export function SettingsActions({ children }) {
  return <div className="flex flex-wrap items-center justify-end gap-3 border-t border-gray-200 pt-5">{children}</div>;
}
